import "./bloc-faq.scss";

const triggersInit = (faq) => {
  const items = faq.querySelectorAll(".blocFaq__item");

  const getItemTrigger = (item) => {
    return item.querySelector(".blocFaq__item__trigger");
  };

  const getItemPanel = (item) => {
    return item.querySelector(".blocFaq__item__panel");
  };

  // toggle handler
  const toggle = (item) => {
    const trigger = getItemTrigger(item);
    const panel = getItemPanel(item);
    const expanded = trigger.getAttribute("aria-expanded") === "true";

    if (expanded) {
      trigger.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      panel.classList.remove("is-open");
    } else {
      // Close currently open item
      items.forEach((otherItem) => {
        const otherTrigger = getItemTrigger(otherItem);
        if (otherTrigger.getAttribute("aria-expanded") === "true") {
          otherTrigger.setAttribute("aria-expanded", "false");
          getItemPanel(otherItem).setAttribute("aria-hidden", "true");
          getItemPanel(otherItem).classList.remove("is-open");
        }
      });

      trigger.setAttribute("aria-expanded", "true");
      panel.removeAttribute("aria-hidden");
      panel.classList.add("is-open");
    }
  };

  items.forEach((item) => {
    const trigger = getItemTrigger(item);
    trigger.addEventListener("click", () => toggle(item));

    trigger.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        trigger.getAttribute("aria-expanded") === "true"
      ) {
        toggle(item);
        trigger.focus();
      }
    });
  });
};

const faqInit = () => {
  const faqs = document.querySelectorAll(".blocFaq__list");

  if (!faqs.length) return;

  Array.from(faqs).forEach((faq) => {
    triggersInit(faq);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  faqInit();
});
